import React from "react";
import {
  Drawer,
  Button,
  Input,
  Form,
  Table,
  Row,
  Col,
  notification,
  Popconfirm,
  Select,
  DatePicker,
  Spin,
  Tooltip,
  Progress,
} from "antd";
import { Column } from "@ant-design/charts";
import { withRouter } from "react-router-dom";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { axiosInstance } from "../../../commons/commons";
import {
  country,
  city,
  project,
  community,
  subCommunity,
  developers,
  legalCompany,
  division,
} from "../../../constants/url";
import moment from "moment";

class Project extends React.Component {
  _isMounted = false;
  state = {
    drawerIsVisible: false,
    editFormFields: [],
    countryData: {
      list: [],
      selectedIndex: null,
    },
    cityData: {
      list: [],
      selectedIndex: null,
    },
    communityData: {
      list: [],
      selectedIndex: null,
    },
    subCommunityData: {
      list: [],
      selectedIndex: null,
    },
    developerData: {
      list: [],
      selectedIndex: null,
    },
    companyData: {
      list: [],
      selectedIndex: null,
    },
    divisionData: {
      list: [],
      selectedIndex: [],
    },
    facilityData: {
      list: [],
      selectedIndex: [],
    },
    tableData: {
      list: [],
      loading: true,
    },
    visualizeDataBy: "noOfBuildings",
  };

  columns = [
    {
      title: "S.N",
      dataIndex: "SN",
      key: "SN",
      align: "center",
      fixed: "left",
      width: 80,
    },

    {
      title: "SysCode",
      dataIndex: "SysCode",
      key: "SysCode",
      align: "center",
      width: 150,
    },
    {
      title: "UserCode",
      dataIndex: "UserCode",
      key: "SysCode",
      align: "center",
      width: 150,
    },
    {
      title: "Project Name",
      dataIndex: "ProjectName",
      key: "ProjectName",
      align: "center",
      width: 150,
    },
    {
      title: "Progress (%)",
      dataIndex: "ProjectProgressPercentage",
      key: "ProjectProgressPercentage",
      align: "center",
      width: 100,
      render: (value) => (
        <Progress
          width="50px"
          type="circle"
          strokeColor={{
            "0%": "#108ee9",
            "100%": "#87d068",
          }}
          percent={value}
        />
      ),
    },
    {
      title: "Completion Date",
      dataIndex: "ProjectProgressDate",
      key: "ProjectProgressDate",
      align: "center",
      width: 100,
      render: (value) => (value ? value.split("T")[0] : "N/A"),
      sorter: (a, b) =>
        a && b
          ? new Date(a.ProjectProgressDate) - new Date(b.ProjectProgressDate)
          : a.ProjectProgressDate - b.ProjectProgressDate,
    },
    {
      title: "Created At",
      dataIndex: "DateCreated",
      key: "DateCreated",
      align: "center",
      width: 150,
      render: (value) => (value ? value.split("T")[0] : "N/A"),
      sorter: (a, b) => new Date(a.DateCreated) - new Date(b.DateCreated),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      width: 110,
      render: (_, item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <EditOutlined
              style={{ color: "#1890ff" }}
              onClick={async () => {
                const tmpList = [];
                let state = this.state;
                // populate information for this project
                Object.keys(item).map((key) => {
                  tmpList.push({ name: key, value: item[key] });
                  return key;
                });
                tmpList.push({
                  name: "ProjectProgressDate",
                  value: item.ProjectProgressDate
                    ? moment(item.ProjectProgressDate)
                    : null,
                });
                // populate and override especially the dropdown informations
                for (let country of state.countryData.list)
                  if (item.CountryID === country.CountryID) {
                    state.countryData.selectedIndex =
                      state.countryData.list.indexOf(country);
                    tmpList.push({
                      name: "CountryID",
                      value:
                        "country+-" +
                        state.countryData.list.indexOf(country) +
                        "+-" +
                        country.UserName,
                    });
                    if (state.countryData.selectedIndex != null)
                      await axiosInstance
                        .get(
                          city +
                            "?CountryID=" +
                            state.countryData.list[
                              state.countryData.selectedIndex
                            ].CountryID
                        )
                        .then((res) => {
                          if (res.data.success)
                            state.cityData = {
                              list: res.data.message,
                              selectedIndex: null,
                            };
                        })
                        .catch(() => {});
                    break;
                  }
                // reset country form if none selected or doesnot match
                if (state.countryData.selectedIndex === null)
                  tmpList.push({ name: "CountryID", value: null });
                for (let city of state.cityData.list)
                  if (item.CityID === city.CityID) {
                    state.cityData.selectedIndex =
                      state.cityData.list.indexOf(city);
                    tmpList.push({
                      name: "CityID",
                      value:
                        "city+-" +
                        state.cityData.list.indexOf(city) +
                        "+-" +
                        city.UserName,
                    });
                    if (state.cityData.selectedIndex != null)
                      await axiosInstance
                        .get(
                          community +
                            "?CityID=" +
                            state.cityData.list[state.cityData.selectedIndex]
                              .CityID
                        )
                        .then((res) => {
                          if (res.data.success)
                            state.communityData = {
                              list: res.data.message,
                              selectedIndex: null,
                            };
                        })
                        .catch(() => {});
                    break;
                  }
                if (state.cityData.selectedIndex === null)
                  tmpList.push({ name: "CityID", value: null });
                for (let community of state.communityData.list)
                  if (item.CommunityID === community.CommunityID) {
                    state.communityData.selectedIndex =
                      state.communityData.list.indexOf(community);
                    tmpList.push({
                      name: "CommunityID",
                      value:
                        "community+-" +
                        state.communityData.list.indexOf(community) +
                        "+-" +
                        community.UserName,
                    });
                    if (state.communityData.selectedIndex != null)
                      await axiosInstance
                        .get(
                          subCommunity +
                            "?CommunityID=" +
                            state.communityData.list[
                              state.communityData.selectedIndex
                            ].CommunityID
                        )
                        .then((res) => {
                          if (res.data.success)
                            state.subCommunityData = {
                              list: res.data.message,
                              selectedIndex: null,
                            };
                        })
                        .catch(() => {});
                    break;
                  }
                if (state.communityData.selectedIndex === null)
                  tmpList.push({ name: "CommunityID", value: null });
                for (let subCommunity of state.subCommunityData.list)
                  if (item.SubCommunityID === subCommunity.SubCommunityID) {
                    state.subCommunityData.selectedIndex =
                      state.subCommunityData.list.indexOf(subCommunity);
                    tmpList.push({
                      name: "SubCommunityID",
                      value:
                        "subCommunity+-" +
                        state.subCommunityData.list.indexOf(subCommunity) +
                        "+-" +
                        subCommunity.UserName,
                    });
                    break;
                  }
                if (state.subCommunityData.selectedIndex === null)
                  tmpList.push({ name: "SubCommunityID", value: null });
                for (let developer of state.developerData.list)
                  if (item.MasterDeveloperID === developer.CompanyID) {
                    state.developerData.selectedIndex =
                      state.developerData.list.indexOf(developer);
                    tmpList.push({
                      name: "MasterDeveloperID",
                      value:
                        "developer+-" +
                        state.developerData.list.indexOf(developer) +
                        "+-" +
                        developer.CompanyName,
                    });
                    break;
                  }
                if (state.developerData.selectedIndex === null)
                  tmpList.push({ name: "MasterDeveloperID", value: null });
                for (let company of state.companyData.list)
                  if (item.LegalCompany_Id === company.LegalCompanyID) {
                    state.companyData.selectedIndex =
                      state.companyData.list.indexOf(company);
                    tmpList.push({
                      name: "LegalCompany_Id",
                      value:
                        "company+-" +
                        state.companyData.list.indexOf(company) +
                        "+-" +
                        company.CompanyName,
                    });
                    if (state.companyData.selectedIndex != null)
                      await axiosInstance
                        .get(
                          division +
                            "?LegalCompanyID=" +
                            state.companyData.list[
                              state.companyData.selectedIndex
                            ].LegalCompanyID
                        )
                        .then((res) => {
                          if (res.data.success)
                            state.divisionData = {
                              list: res.data.message,
                              selectedIndex: [],
                            };
                        })
                        .catch(() => {});
                    break;
                  }
                if (state.companyData.selectedIndex === null)
                  tmpList.push({ name: "LegalCompany_Id", value: null });
                // division filter
                for (let division of state.divisionData.list)
                  if (item.Division_ID === division.DivisionID) {
                    // push into array
                    state.divisionData.selectedIndex.push(
                      state.divisionData.list.indexOf(division)
                    );
                    break;
                  }
                // populate division as array since its mode is multiple
                tmpList.push({
                  name: "Division_ID",
                  value: state.divisionData.selectedIndex.map(
                    (index) =>
                      "division+-" +
                      index +
                      "+-" +
                      state.divisionData.list[index].UserName
                  ),
                });
                // facility filter
                for (let masterFacility of item.MasterProjectFacilities)
                  for (let facility of state.facilityData.list)
                    if (
                      masterFacility.ProjectFacilityID ===
                      facility.ProjectFacilityID
                    ) {
                      // push into array
                      state.facilityData.selectedIndex.push(
                        state.facilityData.list.indexOf(facility)
                      );
                      break;
                    }
                // populate facility as array since its mode is multiple
                tmpList.push({
                  name: "ProjectFacilities",
                  value: state.facilityData.selectedIndex.map(
                    (index) =>
                      "facility+-" +
                      index +
                      "+-" +
                      state.facilityData.list[index].UserName
                  ),
                });
                state.editFormFields = tmpList;
                state.drawerIsVisible = true;
                this.setState(state);
              }}
            />
            <Popconfirm
              title="Are you sure to delete ?"
              onConfirm={() => {
                axiosInstance
                  .delete(project + "/" + item.ProjectID)
                  .then((res) => {
                    if (res.data.success)
                      notification.success({
                        duration: 3,
                        message: "Success",
                        description: res.data.message || "Done!",
                      });
                    else
                      notification.success({
                        duration: 3,
                        message: "Fail",
                        description:
                          res.data.message || "Something went wrong!",
                      });
                    this.getInitialState().then((st) => {
                      this.resetFields();
                      this.setState(st);
                    });
                  })
                  .catch(() => {});
              }}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <DeleteOutlined style={{ color: "red" }} />
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  formRef = null;

  resetFields = () => {
    if (this.formRef) {
      this.formRef.resetFields();
    }
  };

  getInitialState = async (drawerIsVisible) => {
    let state = {
      drawerIsVisible: drawerIsVisible || false,
      editFormFields: [],
      countryData: {
        list: [],
        selectedIndex: null,
      },
      cityData: {
        list: [],
        selectedIndex: null,
      },
      communityData: {
        list: [],
        selectedIndex: null,
      },
      subCommunityData: {
        list: [],
        selectedIndex: null,
      },
      developerData: {
        list: [],
        selectedIndex: null,
      },
      companyData: {
        list: [],
        selectedIndex: null,
      },
      divisionData: {
        list: [],
        selectedIndex: [],
      },
      facilityData: {
        list: [],
        selectedIndex: [],
      },
      tableData: {
        list: this.state.tableData.list,
        loading: false,
      },
      visualizeDataBy: "noOfBuildings",
    };
    await axiosInstance
      .get(project)
      .then((res) => {
        if (res.data.success) {
          state.tableData.list = res.data.message.map((data, index) => {
            data.SN = index + 1;
            data.key = index;
            data.ProjectProgressPercentage = !data.ProjectProgressPercentage
              ? data.ProjectProgressPercentage === 0
                ? 0
                : 100
              : data.ProjectProgressPercentage;
            return data;
          });
        }
      })
      .catch(() => {});
    await axiosInstance
      .get(country)
      .then((res) => {
        if (res.data.success) state.countryData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(developers)
      .then((res) => {
        if (res.data.success) state.developerData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(legalCompany)
      .then((res) => {
        if (res.data.success) state.companyData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(project + "/facility")
      .then((res) => {
        if (res.data.success) state.facilityData.list = res.data.message;
      })
      .catch(() => {});
    return state;
  };

  onCreateNew = (drawerIsVisible = false) => {
    return this.formRef
      .validateFields()
      .then(async (values) => {
        this.setState({
          tableData: { list: this.state.tableData.list, loading: true },
        });
        values.CountryID = Number(
          this.state.countryData.list[values.CountryID.split("+-")[1]].CountryID
        );
        values.CityID = Number(
          this.state.cityData.list[values.CityID.split("+-")[1]].CityID
        );
        values.CommunityID = Number(
          this.state.communityData.list[values.CommunityID.split("+-")[1]]
            .CommunityID
        );
        values.SubCommunityID = Number(
          this.state.subCommunityData.list[values.SubCommunityID.split("+-")[1]]
            .SubCommunityID
        );
        values.LegalCompany_Id = Number(
          this.state.companyData.list[values.LegalCompany_Id.split("+-")[1]]
            .LegalCompanyID
        );
        values.Division_ID = values.Division_ID.map((division) =>
          Number(
            this.state.divisionData.list[division.split("+-")[1]].DivisionID
          )
        );
        if (values.ProjectFacilities)
          values.ProjectFacilities = values.ProjectFacilities.map((facility) =>
            Number(
              this.state.facilityData.list[facility.split("+-")[1]]
                .ProjectFacilityID
            )
          );
        values.ProjectProgressPercentage = Number(
          values.ProjectProgressPercentage
        );
        await (this.state.editFormFields.length
          ? axiosInstance.put(project, values)
          : axiosInstance.post(project, values)
        )
          .then((res) => {
            if (res && res.data.success) {
              notification.success({
                duration: 3,
                message: "Success",
                description: res.data.message || "Done!",
              });
              this.getInitialState(drawerIsVisible).then((st) => {
                this.resetFields();
                this.setState(st);
              });
            } else
              notification.error({
                message: "Fail",
                description: res.data.message || "Something went wrong!",
              });
          })
          .catch(() => {
            this.setState({
              tableData: { list: this.state.tableData.list, loading: false },
            });
          });
      })
      .catch((err) => {
        this.setState({
          tableData: { list: this.state.tableData.list, loading: false },
        });
      });
  };

  onChange = (value) => {
    if (!value) return;
    let type, theIndex;
    /**
     * check if onchange is for division or not.
     * if division, then value will be type of array
     * since its in multiple mode.
     */
    if (typeof value === "object") {
      theIndex = [];
      for (let division of value) {
        type = division.split("+-")[0];
        theIndex.push(division.split("+-")[1]);
      }
    } else {
      type = value.split("+-")[0];
      theIndex = value.split("+-")[1];
    }
    switch (type) {
      case "company":
        this.setState(
          {
            companyData: {
              list: this.state.companyData.list,
              selectedIndex: theIndex,
            },
          },
          () =>
            axiosInstance
              .get(
                division +
                  "?LegalCompanyID=" +
                  this.state.companyData.list[
                    this.state.companyData.selectedIndex
                  ].LegalCompanyID
              )
              .then((res) => {
                if (res.data.success)
                  this.setState({
                    divisionData: {
                      list: res.data.message,
                      selectedIndex: [],
                    },
                  });
              })
              .catch(() => {})
        );
        break;
      case "division":
        this.setState({
          divisionData: {
            list: this.state.divisionData.list,
            selectedIndex: theIndex,
          },
        });
        break;
      case "facility":
        this.setState({
          facilityData: {
            list: this.state.facilityData.list,
            selectedIndex: theIndex,
          },
        });
        break;
      case "country":
        this.setState(
          {
            countryData: {
              list: this.state.countryData.list,
              selectedIndex: theIndex,
            },
            cityData: {
              list: [],
              selectedIndex: null,
            },
            communityData: {
              list: [],
              selectedIndex: null,
            },
            subCommunityData: {
              list: [],
              selectedIndex: null,
            },
          },
          () =>
            axiosInstance
              .get(
                city +
                  "?CountryID=" +
                  this.state.countryData.list[
                    this.state.countryData.selectedIndex
                  ].CountryID
              )
              .then((res) => {
                if (res.data.success)
                  this.setState({
                    cityData: {
                      list: res.data.message,
                      selectedIndex: null,
                    },
                  });
              })
              .catch(() => {})
        );
        break;
      case "city":
        this.setState(
          {
            cityData: {
              list: this.state.cityData.list,
              selectedIndex: theIndex,
            },
            communityData: {
              list: [],
              selectedIndex: null,
            },
            subCommunityData: {
              list: [],
              selectedIndex: null,
            },
          },
          () =>
            axiosInstance
              .get(
                community +
                  "?CityID=" +
                  this.state.cityData.list[this.state.cityData.selectedIndex]
                    .CityID
              )
              .then((res) => {
                if (res.data.success)
                  this.setState({
                    communityData: {
                      list: res.data.message,
                      selectedIndex: null,
                    },
                  });
              })
              .catch(() => {})
        );
        break;
      case "community":
        this.setState(
          {
            communityData: {
              list: this.state.communityData.list,
              selectedIndex: theIndex,
            },
            subCommunityData: {
              list: [],
              selectedIndex: null,
            },
          },
          () =>
            axiosInstance
              .get(
                subCommunity +
                  "?CommunityID=" +
                  this.state.communityData.list[
                    this.state.cityData.selectedIndex
                  ].CommunityID
              )
              .then((res) => {
                if (res.data.success)
                  this.setState({
                    subCommunityData: {
                      list: res.data.message,
                      selectedIndex: null,
                    },
                  });
              })
              .catch(() => {})
        );
        break;
      default:
        break;
    }
  };

  onReset = () => {
    this.getInitialState().then((st) => this.setState(st));
  };

  componentDidMount() {
    this._isMounted = true;
    this.getInitialState().then((st) =>
      this._isMounted ? this.setState(st) : null
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div>
        <Drawer
          title="New Project"
          placement="right"
          closable={false}
          onClose={() => {
            this.resetFields();
            this.setState({ editFormFields: [], drawerIsVisible: false });
          }}
          visible={this.state.drawerIsVisible}
          width={window.innerWidth - 40 > 400 ? 380 : window.innerWidth - 40}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
              }}
            >
              <Button
                name="create"
                onClick={() => this.onCreateNew()}
                type="primary"
                style={{ borderRadius: 20 }}
              >
                {this.state.editFormFields.length ? "Save" : "Create"}
              </Button>
              {!this.state.editFormFields.length ? (
                <Button
                  style={{ borderRadius: 20 }}
                  onClick={() => this.onCreateNew(true)}
                  type="primary"
                >
                  Create and add another
                </Button>
              ) : null}
              <Button
                style={{ borderRadius: 20 }}
                onClick={() => {
                  this.resetFields();
                  this.setState({
                    editFormFields: [],
                    drawerIsVisible: this.state.editFormFields.length > 0,
                  });
                }}
              >
                Cancel
              </Button>
            </div>
          }
        >
          <Form
            layout="horizontal"
            colon={false}
            ref={(ref) => (ref ? (this.formRef = ref) : null)}
            fields={this.state.editFormFields}
            requiredMark
          >
            <Form.Item
              key="ProjectID"
              name="ProjectID"
              label="ProjectID"
              labelAlign="left"
              labelCol={{ span: 24 }}
              hidden
              rules={[{ required: false, message: "Please enter project id" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="UserCode"
              name="UserCode"
              label="User Code"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please enter user code" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="ProjectName"
              name="ProjectName"
              label="ProjectName"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please enter project name" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="CountryID"
              name="CountryID"
              label="Country"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select country" }]}
            >
              <Select
                showSearch
                placeholder="Select a country"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.countryData.list.map((country, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"country+-" + index + "+-" + country.UserName}
                    >
                      {country.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="CityID"
              name="CityID"
              label="City"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select city" }]}
            >
              <Select
                showSearch
                placeholder="Select a city"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.cityData.list.map((city, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"city+-" + index + "+-" + city.UserName}
                    >
                      {city.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="CommunityID"
              name="CommunityID"
              label="Community"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select community" }]}
            >
              <Select
                showSearch
                placeholder="Select a community"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.communityData.list.map((community, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"community+-" + index + "+-" + community.UserName}
                    >
                      {community.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="SubCommunityID"
              name="SubCommunityID"
              label="Sub Community"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: true, message: "Please select sub community" },
              ]}
            >
              <Select
                showSearch
                placeholder="Select a sub community"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.subCommunityData.list.map((subCommunity, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={
                        "subCommunity+-" + index + "+-" + subCommunity.UserName
                      }
                    >
                      {subCommunity.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="MasterDeveloperID"
              name="MasterDeveloperID"
              label="Master Developer"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: false, message: "Please select master developer" },
              ]}
            >
              <Select
                showSearch
                placeholder="Select a master developer"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.developerData.list.map((developer, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"developer+-" + index + "+-" + developer.UserName}
                    >
                      {developer.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="ProjectProgressPercentage"
              name="ProjectProgressPercentage"
              label="Progress (%)"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please enter progress" }]}
            >
              <Input type="number"></Input>
            </Form.Item>
            <Form.Item
              key="ProjectProgressDate"
              name="ProjectProgressDate"
              label="Completion Date"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: false, message: "Please enter completion date" },
              ]}
            >
              <DatePicker
                // format={this.state.dateFormat}
                // allowClear={false}
                style={{
                  width: "100%",
                }}
                // onChange={(val) => {
                //   let state = this.state;
                //   state.complaintData.ComplaintDate = val;
                //   this.setState(state);
                // }}
                // value={this.state.complaintData.ComplaintDate}
              ></DatePicker>
            </Form.Item>
            <Form.Item
              key="ProjectFacilities"
              name="ProjectFacilities"
              label="ProjectFacilities"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please select project facility(s)",
                },
              ]}
            >
              <Select
                showSearch
                mode="multiple"
                placeholder="Select facility(s)"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.facilityData.list.map((facility, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"facility+-" + index + "+-" + facility.UserName}
                    >
                      {facility.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="ProjectInformation"
              name="ProjectInformation"
              label="Status Permit"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please enter information" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="EscroAccountDetail"
              name="EscroAccountDetail"
              label="Account information"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter account information",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="BeneficiaryName"
              name="BeneficiaryName"
              label="Beneficiary Name"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter beneficiary information",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="BeneficiaryBank"
              name="BeneficiaryBank"
              label="Beneficiary Bank"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter beneficiary bank",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="BeneficiaryAccNo"
              name="BeneficiaryAccNo"
              label="Beneficiary Acc. No."
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter beneficiary account number",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="SwiftCode"
              name="SwiftCode"
              label="Swift Code"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter swift code",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="IBANNo"
              name="IBANNo"
              label="IBAN Number"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter IBAN number",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="ProjectFeatures"
              name="ProjectFeatures"
              label="Project Features"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter project features",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="LegalCompany_Id"
              name="LegalCompany_Id"
              label="Company"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select a company" }]}
            >
              <Select
                showSearch
                placeholder="Select a company"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.companyData.list.map((company, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"company+-" + index + "+-" + company.CompanyName}
                    >
                      {company.CompanyName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="Division_ID"
              name="Division_ID"
              label="Division"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select division(s)" }]}
            >
              <Select
                showSearch
                mode="multiple"
                placeholder="Select division(s)"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.divisionData.list.map((division, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"division+-" + index + "+-" + division.UserName}
                    >
                      {division.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Form>
        </Drawer>
        <Row style={{ margin: "10px 10px 10px 10px" }}>
          <Col span={4} xs={8} sm={8} md={4} lg={4}>
            <Tooltip title="Visualize data by">
              <Select
                disabled={!this.state.tableData.list.length}
                style={{ width: "100%", borderRadius: 20 }}
                onChange={(val) => this.setState({ visualizeDataBy: val })}
                value={this.state.visualizeDataBy}
              >
                <Select.Option key={0} value="noOfBuildings">
                  No. of Buildings
                </Select.Option>
                <Select.Option key={1} value="ProjectProgressPercentage">
                  Progress
                </Select.Option>
              </Select>
            </Tooltip>
          </Col>
          <Col
            span={16}
            xs={8}
            sm={8}
            md={16}
            lg={16}
            style={{ textAlign: "center" }}
          >
            <h3>Project</h3>
          </Col>
          <Col
            span={4}
            xs={8}
            sm={8}
            md={4}
            lg={4}
            style={{ textAlign: "right" }}
          >
            <Button
              type="primary"
              onClick={() => {
                this.setState({ drawerIsVisible: true });
              }}
              style={{ borderRadius: 20 }}
            >
              New
            </Button>
          </Col>
        </Row>
        <Spin
          spinning={this.state.tableData.loading}
          tip="fetching and populating data..."
        >
          <Row gutter={48} style={{ paddingLeft: 10, paddingRight: 10 }}>
            {this.state.tableData.list.length ? (
              <>
                <Col span={12} xs={24} sm={24} md={8} lg={12}>
                  <Row>
                    <Col
                      span={24}
                      style={{
                        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                        transition: "0.3s",
                        // borderRadius: 20,
                        width: "100%",
                        padding: 10,
                      }}
                    >
                      <Column
                        data={this.state.tableData.list}
                        xField="ProjectName"
                        yField={this.state.visualizeDataBy}
                        xAxis={{
                          label: {
                            autoRotate: false,
                          },
                        }}
                        // height={200}
                        // scrollbar={{
                        //   type: "horizontal",
                        // }}
                        slider={{
                          start: 0,
                          end: 1,
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={0}
                  xs={24}
                  sm={24}
                  md={0}
                  lg={0}
                  style={{ marginTop: 10 }}
                ></Col>
              </>
            ) : null}
            <Col
              {...(this.state.tableData.list.length
                ? { span: 12, xs: 24, sm: 24, md: 16, lg: 12 }
                : { span: 24 })}
            >
              <Table
                // loading={this.state.tableData.loading}
                dataSource={this.state.tableData.list}
                columns={this.columns}
                scroll={{ y: window.innerHeight - 290 }}
                pagination={{
                  size: "small",
                  disabled: false,
                  defaultPageSize: 20,
                  showQuickJumper: true,
                  showSizeChanger: true,
                  total: this.state.tableData.list.length,
                }}
                style={{
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                  transition: "0.3s",
                  borderRadius: 20,
                  width: "100%",
                }}
              ></Table>
            </Col>
          </Row>
        </Spin>
      </div>
    );
  }
}

export default withRouter(Project);
